import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-fin-flujoPEP',
    standalone: false,
    templateUrl: './fin-flujoPEP.component.html',
    styleUrl: './fin-flujoPEP.component.scss',
})
export class FinFlujoPEPComponent implements OnInit {
    sessionId: string = '';

    constructor(
        private router: Router,
        private route: ActivatedRoute
    ) {

    }

    getLocalStorage(): number {
        return Number(localStorage.getItem('session_id'))
    }

    ngOnInit(): void {
        this.sessionId = this.getLocalStorage().toString();
    }

    volverInicio(): void {
        this.router.navigate(['./']);
    }
}
